import React from 'react';
import Icon from './Icon';
import { faCube } from '@fortawesome/free-solid-svg-icons'
import { ATS_TEMPLATES, DESIGN_TEMPLATES, TEMPLATE_LABELS, FONTS } from './constants';
import PdfDownloadButton from './templates/pdf/PdfDownloadButton';

function Header({dispatch, initialValues}) {
    const {template, selectedFont} = initialValues;

    const handleSelectedFontChange = (event) => {
        const {target} = event;
        const {name, value} = target;
        dispatch({
            type: 'field',
            field: name,
            value: value
        })
    }

    const handleSelectedTemplateChange = (event) => {
        const {target} = event;
        const {name, value} = target;
        dispatch({
            type: 'field',
            field: name,
            value: value
        })
    }

    return (
        <div className='template-container'>

            <div className='App-logo'>
                <a className="navbar-brand" href="#"><Icon icon={faCube} />  {' '}
                    BuildCV<small>An initiative to help people build CV.</small></a>
            </div>
            
            <div className="form-floating">
            <select name="template"
                    className="form-select"
                    value={template}
                    id="templateTheme"
                    aria-label="Select theme"
                    onChange={handleSelectedTemplateChange}>
                <optgroup label="ATS-Friendly">
                    {ATS_TEMPLATES.map(item => <option key={item} value={item}>{TEMPLATE_LABELS[item]}</option>)}
                </optgroup>
                <optgroup label="Designs">
                    {DESIGN_TEMPLATES.map(item => <option key={item} value={item}>{TEMPLATE_LABELS[item]}</option>)}
                </optgroup>
            </select>
                <label htmlFor="templateTheme">Selected theme</label>
            </div>
            <div className="form-floating">
                <select name="selectedFont" 
                        className="form-select" 
                        value={selectedFont} 
                        id="selectedFont" 
                        aria-label="Select font style"
                        onChange={handleSelectedFontChange}>
                    {FONTS.map(item => <option key={item} value={item}>{item}</option>)}
                </select>
                <label htmlFor="selectedFont">Selected font</label>
            </div>
            <div className='print-container'>
                <PdfDownloadButton state={initialValues} />
            </div>
        </div>
    );
}

export default Header;